import { useState, useEffect } from 'react';

const useDebouncedValue = <T>(value: T, wait = 500) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (debounced !== value) {
        setDebounced(value);
      }
    }, wait);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return debounced;
};

export default useDebouncedValue;
